'use strict';
var ACC;
ACC.megamenu = {

    _autoload: [
        'onMenuNodeNavigation',
        'initDesktopMegaMenuAnalytics'
    ],

    _const: {
        CLASS_LEVEL_1_ACTIVE: 'l1-active',
        CLASS_LEVEL_2_ACTIVE: 'l2-active',
        CLASS_EXPAND_BUTTON_ICON_DOWN: 'icon-down-open-mini',
        CLASS_EXPAND_BUTTON_ICON_UP: 'icon-up-open-mini',

        SELECTOR_FIRST_LINK: 'a:first',
        SELECTOR_FIRST_BUTTON: 'button:first',
        SELECTOR_EXPAND_BUTTON_ICON: '.main-navigation-item__expand-button__icon',

        SELECTOR_LEVEL_0_NODES: '.tree-navigation.main-navigation-item',
        SELECTOR_LEVEL_0_EXPAND_BUTTON: '.main-navigation-item__expand-button',

        SELECTOR_LEVEL_1_CONTAINER: '.level-1-navigation-container',
        SELECTOR_LEVEL_1_NODES: '.tree-navigation.main-navigation-item .level-1-navigation-container .title',
        SELECTOR_LEVEL_1_ACTIVE: '.title.l1-active',
        SELECTOR_LEVEL_1_ACTIVE_FOCUSABLE_ELEMENT: '.title.l1-active .name',

        SELECTOR_LEVEL_2_CONTAINER: '.level-2-navigation-container',
        SELECTOR_LEVEL_2_NODES: '.tree-navigation.main-navigation-item .level-2-navigation-container .level_2',
        SELECTOR_LEVEL_2_ACTIVE_NAVIGATION: '.sub-navigation-section.l2-active',

        SELECTOR_SUB_NAV_CONTAINER: '.sub-navigation',
        SELECTOR_SUB_NAV_ITEM: '.tree-navigation .sub-navigation-section',
        SELECTOR_SUB_NAV_BUTTON: '.sub-navigation button:first',
    },

    hideMegaMenu: function() {
        $('.title')
            .removeClass(this._const.CLASS_LEVEL_1_ACTIVE)
            .children('button.name')
            .attr('aria-expanded', 'false');

        $(this._const.SELECTOR_SUB_NAV_ITEM).removeClass(this._const.CLASS_LEVEL_2_ACTIVE);
        $(this._const.SELECTOR_LEVEL_0_NODES).removeClass('md-show-sub');
        $(this._const.SELECTOR_LEVEL_0_EXPAND_BUTTON).attr('aria-expanded', 'false');

        $(this._const.SELECTOR_EXPAND_BUTTON_ICON)
            .removeClass(this._const.CLASS_EXPAND_BUTTON_ICON_UP)
            .addClass(this._const.CLASS_EXPAND_BUTTON_ICON_DOWN);

        $('.main-content .layer').removeClass('bg-transparent');

        $(this._const.SELECTOR_LEVEL_1_CONTAINER).off('keydown', this.level1KeyboardHandler);
        $(this._const.SELECTOR_LEVEL_2_CONTAINER).off('keydown', this.level2KeyboardHandler);
    },

    showMegaMenu: function($element) {
        var $expandButton = $element.find(this._const.SELECTOR_LEVEL_0_EXPAND_BUTTON);
        var $expandButtonIcon = $expandButton.find(this._const.SELECTOR_EXPAND_BUTTON_ICON);
        var $titleElement = $element.find('.title').first();
        var uid = $titleElement.attr('data-categoryid');
        var hasChildSection = $element.hasClass('has-sub');

        $expandButton.attr('aria-expanded', 'true');

        $expandButtonIcon
            .removeClass(this._const.CLASS_EXPAND_BUTTON_ICON_DOWN)
            .addClass(this._const.CLASS_EXPAND_BUTTON_ICON_UP);

        $titleElement
            .addClass(this._const.CLASS_LEVEL_1_ACTIVE)
            .children('button.name')
            .attr('aria-expanded', 'true');

        $(this._const.SELECTOR_SUB_NAV_ITEM + '.' + uid).addClass(this._const.CLASS_LEVEL_2_ACTIVE);
        $element.addClass('md-show-sub');

        if (hasChildSection) {
            $('.main-content .layer').addClass('bg-transparent');
        }

        $element.find(this._const.SELECTOR_LEVEL_1_CONTAINER).on('keydown', this.level1KeyboardHandler);
        $element.find(this._const.SELECTOR_LEVEL_2_CONTAINER).on('keydown', this.level2KeyboardHandler);
    },

    level1KeyboardHandler: function(event) {
        // Right key
        if (event.which === 39) {
            $(event.target).trigger('click');
        }

        // Escape Key
        if (event.which === 27) {
            ACC.megamenu.hideMegaMenu();

            $(event.currentTarget)
                .parents(ACC.megamenu._const.SELECTOR_LEVEL_0_NODES)
                .find(ACC.megamenu._const.SELECTOR_LEVEL_0_EXPAND_BUTTON)
                .focus();
        }

        // Tab
        if (event.which === 9 && event.shiftKey === false) {
            // It's the last L1
            if ($(event.target).parent().next().length === 0) {
                ACC.megamenu.hideMegaMenu();
            }
        }

        // Up arrow
        if (event.which === 38) {
            var $prevL1Menu = $(event.target).parent().prev();

            // It's not the first L1
            if ($prevL1Menu.length > 0) {
                event.preventDefault();
                event.stopPropagation();

                $prevL1Menu.children('button.name').focus();
            }
        }

        // Down arrow
        if (event.which === 40) {
            var $nextL1Menu = $(event.target).parent().next();

            // It's not the last L1
            if ($nextL1Menu.length > 0) {
                event.preventDefault();
                event.stopPropagation();

                $nextL1Menu.children('button.name').focus();
            }
        }
    },

    level2KeyboardHandler: function(event) {
        var $currentL2MenuItem, $activeL2MenuItems, $nextL1Menu, index;

        // Escape Key or Left Key
        if (event.which === 27 || event.which === 37) {
            $(event.currentTarget)
                .siblings(ACC.megamenu._const.SELECTOR_LEVEL_1_CONTAINER)
                .find(ACC.megamenu._const.SELECTOR_LEVEL_1_ACTIVE_FOCUSABLE_ELEMENT)
                .focus();
        }

        // Tab
        if (event.which === 9 && event.shiftKey === false) {
            $currentL2MenuItem = $(event.target);
            $activeL2MenuItems = $(event.currentTarget).find('.l2-active li a');
            index = $activeL2MenuItems.index($currentL2MenuItem);

            // It's the last L2
            if (index === $activeL2MenuItems.length - 1) {

                $nextL1Menu = $(event.currentTarget)
                    .siblings(ACC.megamenu._const.SELECTOR_LEVEL_1_CONTAINER)
                    .find(ACC.megamenu._const.SELECTOR_LEVEL_1_ACTIVE)
                    .next();

                // It's not the last L1
                if ($nextL1Menu.length > 0) {
                    event.preventDefault();
                    event.stopPropagation();

                    $nextL1Menu.children('button.name').focus();
                }
                else {
                    ACC.megamenu.hideMegaMenu();
                }
            }
        }

        // Shift + Tab
        if (event.which === 9 && event.shiftKey === true) {
            $currentL2MenuItem = $(event.target);
            $activeL2MenuItems = $(event.currentTarget).find('.l2-active li a');
            index = $activeL2MenuItems.index($currentL2MenuItem);

            // It's the first L2
            if (index === 0) {
                event.preventDefault();
                event.stopPropagation();

                $(event.delegateTarget)
                    .siblings(ACC.megamenu._const.SELECTOR_LEVEL_1_CONTAINER)
                    .find(ACC.megamenu._const.SELECTOR_LEVEL_1_ACTIVE_FOCUSABLE_ELEMENT)
                    .focus();
            }
        }

        // Up arrow
        if (event.which === 38) {
            $currentL2MenuItem = $(event.target);
            $activeL2MenuItems = $(event.currentTarget).find('.l2-active li a');
            index = $activeL2MenuItems.index($currentL2MenuItem);

            // It's not the first L2
            if (index > 0) {
                event.preventDefault();
                event.stopPropagation();
                $activeL2MenuItems[index - 1].focus();
            }
        }

        // Down arrow
        if (event.which === 40) {
            $currentL2MenuItem = $(event.target);
            $activeL2MenuItems = $(event.currentTarget).find('.l2-active li a');
            index = $activeL2MenuItems.index($currentL2MenuItem);

            // It's not the last L2
            if (index < $activeL2MenuItems.length - 1) {
                event.preventDefault();
                event.stopPropagation();

                $activeL2MenuItems[index + 1].focus();
            }
        }
    },

    onMenuNodeNavigation: function() {
        var self = this;
        var isMegaMenuVisible =  false;
        var isDesktopMinBP = window.matchMedia('(min-width: 1025px)').matches;
        var isTouch = 'ontouchstart' in window ||
        window.DocumentTouch && document instanceof window.DocumentTouch ||
        navigator.maxTouchPoints > 0 ||
        window.navigator.msMaxTouchPoints > 0;

        if (isDesktopMinBP) {
            $(self._const.SELECTOR_LEVEL_0_NODES).on('focusin', '> a', function() {
                self.hideMegaMenu();
            })

            $(document).on('mouseenter', self._const.SELECTOR_LEVEL_0_NODES, function(e) {
                if ($(this).hasClass('md-show-sub')) return;
                if (isMegaMenuVisible) {
                    self.hideMegaMenu();
                    self.showMegaMenu($(this));
                }
            });

            $('.tree-nav-container.main-nav-container .main-navigation-list').hoverIntent({
                over: function() {
                    var $subMenuHoverElement = $(this).find(self._const.SELECTOR_LEVEL_0_NODES + ':hover');
                    if ($subMenuHoverElement.length) {
                        ACC.megamenu.hideMegaMenu();
                        ACC.megamenu.showMegaMenu($subMenuHoverElement);
                    }
                    isMegaMenuVisible = true;
                },
                out: function() {
                    var $subMenuHoverElement = $(this).find(self._const.SELECTOR_LEVEL_0_NODES + ':hover');
                    if (!$subMenuHoverElement.length) {
                        ACC.megamenu.hideMegaMenu();

                        // ABANDON - ANALYTICS (DESKTOP)
                        ACC.gtm.trackMegaMenu_Abandon();
                    }
                    isMegaMenuVisible = false;
                },
                timeout: 200
            });

            /**
             * When Expand button is selected, open sub-navigation & focus first corresponding element
             */
            $(self._const.SELECTOR_LEVEL_0_NODES).on('click', self._const.SELECTOR_LEVEL_0_EXPAND_BUTTON, function(e) {
                var $L0_menuItem = $(e.delegateTarget);
                var $L0_expandButton = $(e.currentTarget);
                var $activeElSubNav = $L0_menuItem.find(self._const.SELECTOR_SUB_NAV_CONTAINER);
                var shouldExpand = $L0_expandButton.attr('aria-expanded') === 'false';

                // Reset Megamenu
                self.hideMegaMenu();

                // Show corresponding Megamenu dropdown
                if (shouldExpand) {
                    self.showMegaMenu($L0_menuItem);
                    if ($activeElSubNav.length !== 0) {
                        $activeElSubNav.find(self._const.SELECTOR_FIRST_BUTTON).focus();
                    } else {
                        $L0_menuItem.find(self._const.SELECTOR_SUB_NAV_BUTTON).focus();
                    }
                }
            });

            /*
             * When "Click" / "Return" key is pressed during level 1 navigation - open sub-navigation & focus first corresponding element
             */
            $('.level_1.has-sub').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                var uid = $(this).attr('data-categoryid');

                $(this)
                    .siblings()
                    .removeClass(self._const.CLASS_LEVEL_1_ACTIVE)
                    .children('button.name').attr('aria-expanded', 'false');

                $(this)
                    .addClass(self._const.CLASS_LEVEL_1_ACTIVE)
                    .children('button.name').attr('aria-expanded', 'true');

                $(self._const.SELECTOR_SUB_NAV_ITEM).removeClass(self._const.CLASS_LEVEL_2_ACTIVE);

                $(self._const.SELECTOR_SUB_NAV_ITEM + '.' + uid)
                    .addClass(self._const.CLASS_LEVEL_2_ACTIVE)
                    .find(self._const.SELECTOR_FIRST_LINK)
                    .focus();
            });
        }

        if (isTouch){
            $(document).on('touchstart', function(event) {
                if (!event.target.className.includes('nav-cancel')) {
                    var $megaMenu = $('li.md-show-sub');
                    if($megaMenu.length > 0 && !$megaMenu.is(event.target) && $megaMenu.has(event.target).length === 0) {
                        ACC.megamenu.hideMegaMenu();
                        ACC.gtm.trackMegaMenu_Abandon();
                    };
                } else {
                    setTimeout(function() {
                        ACC.megamenu.hideMegaMenu();
                        ACC.gtm.trackMegaMenu_Abandon();
                    }, 300);
                }
            });

            $(this._const.SELECTOR_LEVEL_0_NODES).on('touchstart', 'a:not(.name)', function(event) {
                var $liElement = $(this).parent('li');

                if ($liElement.hasClass('has-sub') && !$liElement.find('.sub-navigation').height()) {
                    event.preventDefault();
                    $liElement.find('.nav-cancel').show();
                    ACC.megamenu.hideMegaMenu();
                    ACC.megamenu.showMegaMenu($liElement);
                    ACC.megamenu.attachMegaMenu_L0(event, 'expand');
                };
            });
        }

        $(self._const.SELECTOR_LEVEL_1_NODES).hoverIntent({
            over: function() {
                var uid = $(this).attr('data-categoryid');

                $(this)
                    .siblings()
                    .removeClass(self._const.CLASS_LEVEL_1_ACTIVE)
                    .children('button.name')
                    .attr('aria-expanded', 'false');

                $(this)
                    .addClass(self._const.CLASS_LEVEL_1_ACTIVE)
                    .children('button.name')
                    .attr('aria-expanded', 'true');

                $(self._const.SELECTOR_SUB_NAV_ITEM).removeClass(self._const.CLASS_LEVEL_2_ACTIVE);
                $(self._const.SELECTOR_SUB_NAV_ITEM + '.' + uid).addClass(self._const.CLASS_LEVEL_2_ACTIVE);
            },
            out: function() {
            },
            timeout: 0,
            interval: 50
        });
    },


    /**
     * @description get data from L0_NODES to be sent to GA | Tab-active class removes
     * the default outline on focused elements, which is needed when using the tab key (accesibility)
     * @param event triggered event
     * @param element jQuery element
     * @param mobileMMState state of the mobile MegaMenu L0_NODE 'expand' | 'collapse'
     * leave 'mobileMMState' undefined (for desktop only) in order to navigate to URL
     */
    attachMegaMenu_L0: function(event, mobileMMState) {
        var element = event.target;

        event.preventDefault();
        event.stopPropagation();

        var L0_NODE = (element.text).trim();
        var L0_URL = (element.href).trim();

        ACC.gtm.trackMegaMenu_L0(L0_NODE, L0_URL, mobileMMState);
    },


    /**
     * @description get data from L2_NODES to be sent to GA
     * @param event triggered event
     * @param element jQuery element
     */
    attachMegaMenu_L2: function(event, element) {
            var $this = element;

            event.preventDefault();
            event.stopPropagation();

            var L0_NODE_LABEL = $this.closest('.level_0').data('category');
            var L1_NODE_LABEL = $this.data('categoryparent');
            var L2_NODE_LABEL = $this.data('category');
            var L2_URL = $this.find('a').prop('href');

            ACC.gtm.trackMegaMenu_L2(L0_NODE_LABEL, L1_NODE_LABEL, L2_NODE_LABEL, L2_URL);
    },


    /**
     * @description capture MegaMenu NODES clicked and send data to GA
     */
    initDesktopMegaMenuAnalytics: function() {
        // LEVEL_0_NODES
        $(this._const.SELECTOR_LEVEL_0_NODES + '.level_0').on('click tap', 'a', function(event) {
            ACC.megamenu.attachMegaMenu_L0(event);
        });

        // LEVEL_2_NODES
        $(this._const.SELECTOR_LEVEL_2_NODES).on('click tap', function(event) {
            ACC.megamenu.attachMegaMenu_L2(event, $(this));
        });
    },

};
